/**
 * Enum used to define system values e.g. values automatically provided by the system
 */
export enum NodeParticleSystemSources {
    /** None */
    None = 0,
    /** Time */
    Time = 1,
    /** Delta time */
    Delta = 2,
    /** Emitter */
    Emitter = 3,
    /** Camera position */
    CameraPosition = 4,
}
